function apiUrl(path) {
	return process.env.VUE_APP_API_ENDPOINT + path
}

module.exports = {
	apiUrl
}